import { UPDATE_PROJECT_ID, UPDATE_PROJECT_NAME, UPDATE_PROJECT_LOCATION, UPDATE_PROJECT_DETAIL } from '../mutation_types.js'

export default {
  namespaced: true,
  state: {
    name: '',
    id: sessionStorage.getItem('projectID') ? sessionStorage.getItem('projectID') : '',
    location: sessionStorage.getItem('projectLocation') ? sessionStorage.getItem('projectLocation') : '',
    details: sessionStorage.getItem('projectToken') ? sessionStorage.getItem('projectToken') : []
  },
  getters: {
    getActiveProjectID: state => {
      return state.id
    },
    getActiveProjectName: state => {
      return state.name
    },
    getActiveProjectDetails: state => {
      return JSON.parse(state.details)
    },
    getActiveProjectLocation: state => {
      return state.location
    }
  },
  mutations: {
    [UPDATE_PROJECT_NAME] (state, projectName) {
      state.name = projectName
    },
    [UPDATE_PROJECT_ID] (state, projectID) {
      sessionStorage.setItem('projectID', projectID)
      state.id = sessionStorage.getItem('projectID')
    },
    [UPDATE_PROJECT_LOCATION] (state, projectLocation) {
      sessionStorage.setItem('projectLocation', projectLocation)
      state.location = sessionStorage.getItem('projectLocation')
    },
    [UPDATE_PROJECT_DETAIL] (state, projectDetail) {
      sessionStorage.setItem('projectToken', JSON.stringify(projectDetail))
      state.details = sessionStorage.getItem('projectToken')
    }
  },
  actions: {
    updateActiveProjectName ({commit}, projectName) {
      commit(UPDATE_PROJECT_NAME, projectName)
    },
    updateActiveProjectLocation ({commit}, projectLocation) {
      commit(UPDATE_PROJECT_LOCATION, projectLocation)
    },
    updateActiveProjectID ({commit}, projectID) {
      commit(UPDATE_PROJECT_ID, projectID)
    },
    updateActiveProjectDetails ({commit}, projectDetail) {
      commit(UPDATE_PROJECT_DETAIL, projectDetail)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/projects_store.js